/** CMS page asset IDs that should render without scroll/reveal animations. */
export const CMS_PAGE_IDS_WITHOUT_ANIMATION = ['team'];

/**
 * @param {string | undefined} pageId
 * @returns {boolean}
 */
export const shouldDisableCmsPageAnimations = pageId =>
  CMS_PAGE_IDS_WITHOUT_ANIMATION.includes(pageId);
